import { translateObject } from '@huggg/bar-staff';
import { propOr } from 'ramda';
import { firstById } from './find';
import { hugggMap, paginatedResponseMap, userMap } from '../translationMaps';
var extract = function extract(embedded, id) {
  return propOr([], id, embedded);
};
export var hugggStatuses = {
  cancelled: 6
};
function getHugggStatus(huggg) {
  var statusMap = {
    0: 'Viewed',
    1: 'Redeeemed',
    5: 'Sent',
    6: 'SMS Reminder sent',
    7: 'Expired',
    12: 'Created'
  };
  if ((huggg.status || huggg.status === 0) && statusMap[huggg.status]) {
    return {
      code: huggg.status,
      label: statusMap[huggg.status]
    };
  }
  return {
    code: null,
    label: 'Unknown'
  };
}
export function translateHuggg(huggg, embedded) {
  var translatedHuggg = translateObject(hugggMap, huggg);
  translatedHuggg.status = getHugggStatus(translatedHuggg);
  var receiver = firstById(extract(embedded, 'users'), propOr(null, 'receiver_id', huggg));
  if (receiver) {
    translatedHuggg.receiver = translateObject(userMap, receiver);
  }
  return translatedHuggg;
}
export function translateHugggs(hugggs, embedded) {
  return hugggs.map(function (huggg) {
    return translateHuggg(huggg, embedded);
  });
}
export function translateHugggPaginatedResponse(data) {
  var translated = translateObject(paginatedResponseMap, data);
  var hugggs = data.data,
    embedded = data.embedded;
  if (translated.data.length) {
    translated.data = translateHugggs(hugggs, embedded);
  }
  return translated;
}